import React from 'react'
import styled from "styled-components"
import ReactHtmlParser from 'react-html-parser'

import "../css/main.css"
import "../components/layout.css"

var BackgroundImage = styled.div`
  background-repeat: no-repeat;
  background-size: auto;
  background-position: 0 100% ;
  background-image:url("${props=>props.src}");
  height: auto;
  display: grid;
  width:100%;
  @media screen and (max-width: 768px) {
  height:auto;
  background-size: contain;
  background-position: 0 100%;
  }
`
var Container =styled.div`
color: #000000;
    padding-top: 50px;
    width: 90%;
    margin: 20px auto;
    font-family: Dm sans;
    @media screen and (max-width: 768px) {
        width: 100%;
  }
`
var ContainerImage =styled.div`
    width: 50%;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    @media screen and (max-width: 768px) {
        width: 100%;
        vertical-align: middle;
  }
`
var Icon = styled.div`
`
var ContainerContent =styled.div`
width: 50%;
    display: inline-block;
    vertical-align: middle;
    text-align:left;
    
    @media screen and (max-width: 768px) {
        width: 90%;
        text-align: center;
        padding:15px;
        font-size: 14px;
  }

`
var Title_Content =styled.h2`
color:#333333;
`
var Content_Desc =styled.p`
    padding: 0px;
`

export default function ContentOnTheRight(props) {
    return (
        <BackgroundImage> 
        <Container>
        <ContainerImage>
          <img style={{width:"95%", borderRadius: "20px"}} src={props.image} alt={props.title}/>
        </ContainerImage>
            <ContainerContent>
           {/* <Icon><img src={props.IconContentRight} alt={props.title}/></Icon> */}
            <Title_Content><h3>{props.title}</h3></Title_Content>
            <Content_Desc> {ReactHtmlParser(props.text)}
            </Content_Desc>
            </ContainerContent>
        </Container>
        </BackgroundImage>
    )
}
